export function normalizeCompanyPermissions(value) {
  if (!Array.isArray(value)) return new Set();
  return new Set(value.filter(Boolean).map(String));
}

export function isFullCompanyAccess(user, access) {
  return user?.type === 'company'
    || access?.is_full_access === true
    || normalizeCompanyPermissions(access?.permissions || user?.permissions).has('*');
}

export function hasCompanyPermission(granted, permission, fullAccess = false) {
  if (fullAccess) return true;
  const set = normalizeCompanyPermissions(granted);
  return set.has('*') || set.has(String(permission));
}

export function hasAnyCompanyPermission(granted, permissions, fullAccess = false) {
  if (fullAccess) return true;
  const set = normalizeCompanyPermissions(granted);
  if (set.has('*')) return true;
  return (Array.isArray(permissions) ? permissions : [permissions])
    .filter(Boolean)
    .some((permission) => set.has(String(permission)));
}

export function hasAllCompanyPermissions(granted, permissions, fullAccess = false) {
  if (fullAccess) return true;
  const set = normalizeCompanyPermissions(granted);
  if (set.has('*')) return true;
  return (Array.isArray(permissions) ? permissions : [permissions])
    .filter(Boolean)
    .every((permission) => set.has(String(permission)));
}
